import { format, isBefore, isValid, parse, startOfToday } from 'date-fns';

import {
  SearchFilterDateMode,
  SearchFilterDateValues,
} from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-date.type';

const ISO_DATE_FORMAT = 'yyyy-MM-dd';

const DATE_KEYS = ['minDate', 'maxDate'] as const;

export function toIsoDate(date: Date): string {
  return format(date, ISO_DATE_FORMAT);
}

export function fromIsoDate(value: string | undefined): Date | undefined {
  if (!value) {
    return undefined;
  }

  const parsed = parse(value, ISO_DATE_FORMAT, new Date());

  return isValid(parsed) && format(parsed, ISO_DATE_FORMAT) === value ? parsed : undefined;
}

export function sanitizeDateFilterValues(values: SearchFilterDateValues): SearchFilterDateValues {
  const minDate = fromIsoDate(values.minDate);

  if (!minDate || isBefore(minDate, startOfToday())) {
    return { minDate: undefined, maxDate: undefined };
  }

  const maxDate = fromIsoDate(values.maxDate);

  if (!maxDate || isBefore(maxDate, minDate)) {
    return { minDate: values.minDate, maxDate: undefined };
  }

  return { minDate: values.minDate, maxDate: values.maxDate };
}

export function getDiscardedDateFilterKeys(
  values: SearchFilterDateValues,
): Array<keyof SearchFilterDateValues> {
  const sanitized = sanitizeDateFilterValues(values);

  return DATE_KEYS.filter((key) => values[key] !== undefined && sanitized[key] === undefined);
}

export function getDateFilterMode(values: SearchFilterDateValues): SearchFilterDateMode | undefined {
  if (!values.minDate) {
    return undefined;
  }

  return values.maxDate ? SearchFilterDateMode.RANGE : SearchFilterDateMode.SINGLE;
}
